export const MATCH_NIGHT_REGIONS = ["EU", "NA"];

export function normalizeMatchNightRegion(region) {
  return MATCH_NIGHT_REGIONS.includes(region) ? region : "EU";
}

export function pickNightsForPreferredRegion(nights, preferredRegion) {
  const region = normalizeMatchNightRegion(preferredRegion);
  const list = Array.isArray(nights) ? nights : [];
  const matching = list.filter((night) => night?.region === region);
  return matching.length > 0 ? matching : list;
}

export function pickNextNightForPreferredRegion(nights, preferredRegion) {
  return pickNightsForPreferredRegion(nights, preferredRegion)[0] || null;
}
